import { AfterViewInit, Component, inject, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { COOKIE_EXPIRATION_MS } from '@agilox/common';
import { Cookie } from '@agilox/common';
import { CookieService } from '@agilox/common';
import { ButtonComponent } from '@agilox/ui';
import { OverlayComponent } from '@agilox/ui';
import { CookieDescriptionComponent } from '../cookie-description/cookie-description.component';

@Component({
	selector: 'cookie-overlay',
	templateUrl: './cookie-overlay.component.html',
	imports: [OverlayComponent, ButtonComponent, TranslatePipe, CookieDescriptionComponent],
})
export class CookieOverlayComponent implements AfterViewInit {
	private service = inject(CookieService);

	overlayOpen = signal<boolean>(false);

	ngAfterViewInit(): void {
		if (!document.cookie.includes('cookieConsent')) {
			this.overlayOpen.set(true);
		}
	}

	accept() {
		const date = new Date();
		date.setTime(date.getTime() + COOKIE_EXPIRATION_MS);
		this.service.setCookie(Cookie.cookieConsent, date.toUTCString());
		this.overlayOpen.set(false);
	}
}
